export default {
  all: [],
  one: {

  },
  generatedExternal: '',
};
